<style scoped>
.user-list-item {
    display: flex;
    align-items: center;
    padding: 0.2rem;
}
</style>

<template>
    <v-dialog v-model="dialog" max-width="400px" scrollable content-class="z-full-width-dialog">
        <v-card>
            <v-card-title class="headline flex-column pa-2">
                <div class="d-flex fill-width">
                    <div class="flex-grow-1">{{$translate('Set shirt numbers')}}</div>
                    <v-btn icon @click="dialog = false" class="float-right"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text>
                <v-progress-circular v-if="loading" size="20" indeterminate color="primary" width="2"></v-progress-circular>
                <template v-else>
                    <div v-for="user in groupMembers" :key="user.id" class="user-list-item">
                        <v-avatar :size="30" class="mr-2">
                            <img :src="'/api/memberapi/image/member/get?size=50x50&id=' + user.id" class="user-image" />
                        </v-avatar>
                        <v-text-field
                            v-model="shirtNumbers[user.id]"
                            type="text"
                            :label="user.name"
                            :min="0"
                            @keypress="isNumberKey"
                            @input="onInput(user.id, $event)"
                        ></v-text-field>
                    </div>
                </template>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :loading="saving" :disabled="!changed">{{$translate('Save')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'zoezi-teamsport-set-shirt-numbers-dialog',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        groupId: {
            type: Number
        }
    },

    data: () => ({
        loading: false,
        group: null,
        shirtNumbers: {},
        saving: false
    }),

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        groupMembers() {
            if (!this.group) {
                return [];
            }
            return this.group.users.concat().sort((a, b) => a.name.localeCompare(b.name));
        },
        changed() {
            if (!this.group) {
                return false;
            }
            return this.group.users.some(user => {
                return this.shirtNumbers[user.id] != this.getShirtNumber(user.id);
            });
        }
    },

    watch: {
        groupId: {
            immediate: true,
            handler() {
                if (!this.saving) {
                    this.getGroup();
                }
            }
        }
    },

    methods: {
        isNumberKey(event) {
            // Check if the key pressed is a numeric key
            if (/\D/g.test(event.key)) {
                event.preventDefault();
            }
        },
        onInput(userId, event) {
            // Remove all non-numeric characters in case of copy-paste
            this.shirtNumbers[userId] = event.replace(/\D/g, '');
        },
        getGroup() {
            this.loading = true;
            this.$api.get('/api/memberapi/group/get', {id: this.groupId}).then(group => {
                this.group = group;
                let shirtNumbers = {};
                group.users.forEach(user => {
                    shirtNumbers[user.id] = this.getShirtNumber(user.id);
                });
                this.shirtNumbers = shirtNumbers;
                this.loading = false;
            });
        },
        getShirtNumber(userId) {
            return this.group.shirt_numbers?.find(x => x.user_id === userId)?.shirt;
        },
        save() {
            let shirts = this.group.users.map(user => {
                return {
                    user_id: user.id,
                    shirt: this.shirtNumbers[user.id]
                }
            });
            this.saving = true;
            this.$api.post('/api/memberapi/set_shirt_numbers', {group_id: this.groupId, shirts}).then(() => {
                this.dialog = false;
                this.saving = false;
            });
        }
    }
};
</script>
